<shabic-dialog>
  <shabic-product-form
    [product]="product"
    [request]="request"
  ></shabic-product-form>
</shabic-dialog>
